import { AssetsAPI } from "../../../../../../providers/AssetsAPI";
import { Icon } from "../../../../../components/core/Icon";
import { Input } from "../../../../../components/Input";
import { Textarea } from "../../../../../components/Textarea";
import styles from "../../../../../../styles/add-product.module.scss";
import * as uuid from "uuid";

const handleSetImage = async (e) => {
  return new Promise((resolve) => {
    const file = e.target.files[0];

    if (file) {
      const maxFileSize = 5;
      const fileSize = file.size / 1024 / 1024;
      const fileType = file.type;

      if (fileSize > maxFileSize) {
        alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
        return resolve(false);
      }

      const pattern = /image-*/;

      if (!fileType.match(pattern)) {
        alert({ text: "Arquivo inválido." });
        return resolve(false);
      }

      let reader = new FileReader();
      reader.onload = async (readerEvent) => {
        const imageSrc = readerEvent.target.result;
        const img = new Image();

        img.onload = async () => {
            if (img.width > 500 || img.height > 500) {
              alert({
                text: "A imagem deve ter dimensões de até 500x500",
              });
              return resolve(false);
            }

            const response = await AssetsAPI.PostAssets({
              mime_type: fileType,
              file: imageSrc.split("base64,")[1],
            });
  
            const image = response.getData(null);
            return resolve(image);
          };
  
          img.src = imageSrc;
      };
      reader.readAsDataURL(file);
    }
  });
};

export const ProductNameAndImageStep = ({ product, stylesObj, onChange }) => {
  const handleImage = async (e) => {
    const image = await handleSetImage(e);
    console.log(image);
    if (image) {
      handler({ image });
    }
  };

  const handler = (data) => {
    onChange({ ...product, ...data });
  };

  return (
    <>
      <label
        htmlFor="product-picture"
        className={(stylesObj || styles).customInputFile}
      >
        <input
          key={"file-input-" + uuid.v4()}
          type="file"
          id="product-picture"
          accept="image/*"
          onChange={handleImage}
        />
        {product.image ? (
          <img
            src={`${process.env.REACT_APP_ASSETS_URL}/${product.image}`}
            alt=""
          />
        ) : (
          <Icon name="image-polaroid" size="2x" light />
        )}
      </label>

      <Input
        id="name"
        floatLabel="Nome do produto"
        design="two"
        defaultValue={product.name}
        onChange={(e) => handler({ name: e.target.value })}
      />

      <Textarea
        id="desc"
        design="two"
        placeholder="Ingredientes / Descrição"
        className="mt-20"
        onChange={(e) => handler({ description: e.target.value })}
        defaultValue={product.description}
      />
    </>
  );
};
